import { type IconName } from '@/components';
import { ROUTES } from '@/types/enums';
import { ticketLabels } from '@/utils';

export type NavItemType = {
  href?: string;
  label: string;
  showBorder?: boolean;
  icon: IconName;
  onClick?: () => void;
};

export const createNavigation = (): NavItemType[] => [
  {
    icon: 'Home',
    label: 'Início',
    href: ROUTES.enum['/'],
  },
  {
    icon: 'Wallet',
    label: 'Carteira',
    href: ROUTES.enum['/carteira'],
  },
  {
    icon: 'Tickets',
    label: ticketLabels.pluralCaps,
    href: ROUTES.enum['/meus-titulos'],
  },
  {
    icon: 'Trophy',
    label: 'Resultados',
    href: ROUTES.enum['/resultados'],
  },
];
